/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import "./notifyPermisssionPopup.scss";
// material ui
import Button from "@mui/material/Button";
// handleTotalPersonf
import { withTranslation, useTranslation } from "react-i18next";
// redux
import { useSelector, useDispatch } from "react-redux";
import IconButton from "@mui/material/IconButton";
import StateContext from "../../StateContext";
import DispatchContext from "../../DispatchContext";
import { handleRunServiceWorker } from "../../Functions/getPushNotification";



function NotifyPermisssionPopup(props) {
  const { t } = useTranslation();
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext)
  const { invoiceDetails, invoiceable, selfServe } = props;
  const [isLoading, setIsLoading] = useState(false);



  const handleSubscribe = () => {
    if (invoiceable.service_type == "HotelOrder" && selfServe) {
      handleRunServiceWorker(appState, appDispatch, invoiceDetails?.id)
    }
    appDispatch({
      type: "setAllowNotificationPopupMode",
      allowNotificationPopupMode: false
    })
  }


  return isLoading ? (
    <>loaidng....</>
  ) : (
    <>
      <div
        id="mySidenav"
        className={`notifyPermisssionPopupMain col-12  ${appState.langValue === "ar" ? "notifyPermisssionPopupMainArabic" : " "
          }`}
      >
        {/* <a href="javascript:void(0)" className="closebtn" onClick="closeNav()">&times;</a> */}
        <div className="container-fluid content px-4 pb-3 col-xl-12">
          <div className="d-flex justify-content-end">
            <IconButton
              onClick={() => appDispatch({
                type: "setAllowNotificationPopupMode",
                allowNotificationPopupMode: false
              })}
              className="classForSvgColor mt-2" >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L12 10.9393L17.4697 5.46967C17.7626 5.17678 18.2374 5.17678 18.5303 5.46967C18.8232 5.76256 18.8232 6.23744 18.5303 6.53033L13.0607 12L18.5303 17.4697C18.8232 17.7626 18.8232 18.2374 18.5303 18.5303C18.2374 18.8232 17.7626 18.8232 17.4697 18.5303L12 13.0607L6.53033 18.5303C6.23744 18.8232 5.76256 18.8232 5.46967 18.5303C5.17678 18.2374 5.17678 17.7626 5.46967 17.4697L10.9393 12L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967Z" fill="#22282F" />
              </svg>

            </IconButton>
          </div>
          <hr className="my-1" />

          <p className={` totalAmount text-center text-capitalize mb-0  ${appState.langValue === "ar"
            ? "text-right d-flex"
            : "familyPoppins600"
            }`}>{t("invoice.allow-notification")}</p>
          <div className="bottomBtn">
            <Button
              onClick={() => handleSubscribe()}
              className={` py-3 px-4 clearBtn text-capitalize mt-3 justify-content-center ${appState.langValue === "ar" ? " familyGraphikArabic600" : ""
                }`}
            >
              {" "}
              <span>{t("invoice.allow-notification-2")}</span>{" "}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default withTranslation()(NotifyPermisssionPopup);
